import axiosHttp from "services/axiosHttp";

// Iteration Service Functions
export const iterationService = {
  // Create iteration
  createIteration: async (data) => {
    const response = await axiosHttp.post("/pmo/iteration", data);
    return response.data;
  },

  // Get iteration list with optional params
  getIterationList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/iteration", { params });
    return response.data;
  },

  // Get single iteration by ID
  getIteration: async (id) => {
    const response = await axiosHttp.get(`/pmo/iteration/${id}`);
    return response.data;
  },

  // Update iteration
  updateIteration: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/iteration/${id}`, data);
    return response.data;
  },

  // Delete iteration
  deleteIteration: async (id) => {
    const response = await axiosHttp.delete(`/pmo/iteration/${id}`);
    return response.data;
  },

  // Update iteration status
  updateIterationStatus: async (data) => {
    const response = await axiosHttp.put(`/pmo/iteration/${data.id}/status`, data);
    return response.data;
  },

  //get iteration tasks for me
  getIterationTasksForMe: async (data) => {
    const response = await axiosHttp.get(`/pmo/my/iteration/`, data);
    return response.data;
  }
};
